import {BlipChat} from 'blip-chat-widget';

import { isIdError } from '@/lib/idError';

let blip = new BlipChat();
blip
  .withAppKey('b3JzZWd1cHNwcm9kOjQyOWQzMTZlLTRmOGQtNDgyZS05NDU5LTE1NTA1NjhjYWE3Mw==')
  .withCustomCommonUrl('https://orsegups.chat.blip.ai/')
  .withCustomMessageMetadata ({
    "cpf" : ''
  })
  .withButton({"color":"#052c8b","icon":""})
  .withoutHistory()
  .build();


const state = {
  overlay: false,
  firstAccess: false,
  recEmail: '',
  logoutCallback: () => {
    console.log('logout');
    window.location = '/';
    window.location.reload(true);
    window.location = '/';
  },
  logonCallback: () => {
    console.log('login')
    window.location = '/estatisticas';
    window.location.reload(true);
    window.location = '/estatisticas';
  },
};

const mutations = {
  setFirstAccess(st, firstAccess) {
    st.firstAccess = firstAccess;
  },
  setLogoutCallback(st, callback) {
    st.logoutCallback = callback;
  },
  setLogonCallback(st, callback) {
    st.setLogonCallback = callback;
  },
  setOverlay(st, overlay) {
    st.overlay = overlay;
  },
  setRecEmail(st, param) {
    st.recEmail = param;
  },
};

const getters = {
  currentUserId(st, gt, rootState) {
    const { token } = rootState.session;
    return token && token.userId;
  },
  isPasswordDialogOpen(st) {
    return st.firstAccess;
  },
  accounts(st) {
    console.log('accounts...');
    return st.userAccounts;
  },
  isLoading(st) {
    console.log('isLoading...');
    return st.overlay;
  },
};

const actions = {
  changeFirstAccess({ dispatch, commit, getters: gt }) {
    const userPatch = {
      firstAccess: false,
    };
    commit('setFirstAccess', false);
    console.log('changeFirstAccess...');
    dispatch('users/patch', [gt.currentUserId, userPatch], { root: true });
  },
  async checkUserFirstLogin({
    dispatch, getters: gt, state: st, rootState, commit,
  }) {
    if(blip){
      blip.destroy();
      blip - undefined;
    }
    await dispatch('users/get', gt.currentUserId, { root: true });
    const { firstAccess } = rootState.users.copy;
    const boolFirstAccess = !!+firstAccess;
    if (boolFirstAccess !== st.firstAccess) {
      commit('setFirstAccess', boolFirstAccess);
    }
  },
  /**
   *
   */
  async changeUserPassword({
    commit, dispatch, rootState, getters: gt,
  }, input) {
    await dispatch('users/get', gt.currentUserId, { root: true });
    const { email } = rootState.users.copy;
    const data = {
      email,
      currentPassword: input.currentPasword,
      newPassword: input.newPassword,
    };
    try {
      await dispatch('passwordChanges/create', data, { root: true });
      const result = rootState.passwordChanges.copy;
      if (result.status < 400) {
        this.$notify(result.message, 'info');
        dispatch('changeFirstAccess');
      } else {
        this.$notify('Desculpe, não foi possível alterar sua senha, verifique os dados digitados e tente novamente');
      }
    } catch (e) {
      if (isIdError(e, 'WRONG_PASSWORD')) {
        this.$notify('Senha atual incorreta, por favor verifique e tente novamente');
      } else {
        this.$notify('Erro ao trocar a senha, por favor tente novamente');
      }
    }
    commit('setOverlay', false);
  },
  /**
   *
   */
  async login({ dispatch, commit }, {
    username, password, onSuccess, onLogout,
  }) {
    const query = {
      username,
      password,
    };

    try {
      const tokens = await dispatch('tokens/find', { query }, { root: true });
      if (tokens.length > 0) {
        const token = tokens[0];
        await dispatch('session/create', { token }, { root: true });
        if (onLogout) commit('setLogoutCallback', onLogout);
        dispatch('checkUserFirstLogin');
        onSuccess();
        commit('setLogonCallback', onSuccess);
      } else {
        throw Error('Usuário não encontrado com os dados fornecidos, por favor verifique e tente novamente');
      }
    } catch (err) {
      this.$notify('Dados de login incorretos, tente novamente.');
      commit('setOverlay', false);
    }
  },
  async logout({ dispatch, commit, state: st }) {
    try {
      st.logoutCallback();
      await dispatch('session/remove', {}, { root: true });
      commit('setOverlay', false);
      window.location.reload();
    } catch (err) {
      this.$notify(err);
    }
  },
  /**
   *
   */
  async passwordReset({ dispatch, rootState, commit }, { email }) {
    try {
      await dispatch('passwordResets/create', { email }, { root: true });
      const result = rootState.passwordResets.copy;
      if (result.status < 400) {
        this.$notify(`${result.message} para ${email}`, 'info');
        dispatch('setLogoutCallback');
      } else {
        this.$notify('Desculpe, não foi possível recuperar a senha, verifique os dados digitados e tente novamente');
      }
    } catch (e) {
      this.$notify('Erro ao resetar a senha, por favor tente novamente');
    }
    commit('setOverlay', false);
  },

  async setOverlay({ commit }, value) {
    await commit('setOverlay', value);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
